import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";
import { navlinks, navmegalinks } from "../../utils/data";
import Logo from "../../utils/images/Logo-centrum-for-alla-black-notext.webp";

const Nav = () => {
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [currentOptions, setCurrentOptions] = useState([]);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);

  const handleNavLinkClick = (path) => {
    // Close the hamburger menu if it's open
    if (showHamburgerMenu) {
      setShowHamburgerMenu(false);
    }

    // Toggle the mega menu based on conditions
    if (showMegaMenu && currentOptions.length > 0) {
      setShowMegaMenu(false);
      setCurrentOptions([]);
    } else {
      setShowMegaMenu(true);
      // Set options based on the path clicked
      if (path === "/home") {
        window.location.href = "/";
      } else if (path === "/tjanster") {
        setCurrentOptions(navlinks);
      } else if (path === "/privacy-policy") {
        window.location.href = "/privacy-policy";
      } else if (path === "/om-oss") {
        window.location.href = "/om-oss";
      } else if (path === "/kundcase") {
        window.location.href = "/kundcase";
      } else {
        setCurrentOptions([]);
      }
    }
  };

  const closeMegaMenu = () => {
    setShowMegaMenu(false);
    setCurrentOptions([]);
  };

  const closeHamburgerMenu = () => {
    setShowHamburgerMenu(false);
  };

  return (
    <div>
      <nav className="nav-container">
        <div className="nav-left">
          <Link to="/">
            <img className="logo" src={Logo} alt="logo" />
          </Link>
        </div>
        <div className="nav-center">
          {navmegalinks.slice(0, 5).map((link) => (
            <a
              key={link.id}
              href={link.path}
              onClick={(e) => {
                e.preventDefault();
                handleNavLinkClick(link.path);
              }}
            >
              {link.label}
            </a>
          ))}
        </div>
        <div className="nav-right">
          <button onClick={() => (window.location.href = "/kontakt")}>
            Kontakt
          </button>
        </div>
        <div
          className="hamburger"
          onClick={() => setShowHamburgerMenu(!showHamburgerMenu)}
        >
          &#9776; {/* Hamburger icon */}
        </div>
      </nav>

      {showHamburgerMenu && (
        <div className="hamburger-menu">
          <div className="close-button" onClick={closeHamburgerMenu}>
            &times; {/* Close icon */}
          </div>
          {navmegalinks.map((link) => (
            <a
              key={link.id}
              href={link.path}
              onClick={(e) => {
                e.preventDefault();
                handleNavLinkClick(link.path);
              }}
            >
              {link.label}
            </a>
          ))}
        </div>
      )}

      {showMegaMenu && currentOptions.length > 0 && (
        <div className="mega-menu show" onClick={closeMegaMenu}>
          <div className="mega-menu-section services-description">
            <h2>Våra Tjänster</h2>
            <p className="mega-menu-p">
              Här kan du hitta alla tjänster vi erbjuder. Klicka på en tjänst
              för att lära dig mer om vad vi kan erbjuda dig.
            </p>
          </div>

          <div className="mega-menu-section blog-links">
            <h2>Tjänster</h2>
            {currentOptions.map((item) => (
              <div key={item.id} className="menu-item">
                <h3>
                  <ul>
                    <li>
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.label}
                      </a>
                    </li>
                  </ul>
                </h3>
              </div>
            ))}
          </div>

          <div className="mega-menu-section blog-links">
            <h2>Våra Blogginlägg</h2>
            <ul>
              <li>
                <a href="/marknadsforingskampanj-blog">
                  Digital marknadsföringskampanj
                </a>
              </li>
              <li>
                <a href="/digitala-strategier-blog">Digitala strategier</a>
              </li>
              <li>
                <a href="/seo-grunder-blog">SEO Grunder</a>
              </li>
              {/* Lägg till fler blogglänkar vid behov */}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Nav;
